var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoeOwlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.843,
    height: 51.497,
    viewBox: "0 0 39.843 51.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-802.178 -627.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M24.831,98.316a16.164,16.164,0,0,0-15.821,19.4c1.454,17.778,14.74,27.262,31.969,30.452v-33.7A16.148,16.148,0,0,0,24.831,98.316",
    transform: "translate(794.319 529.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M40.755,148.718a.8.8,0,0,1-.141-.013c-19.661-3.641-31.235-14.686-32.6-31.107a16.926,16.926,0,1,1,33.517-3.357v33.7a.779.779,0,0,1-.777.777M24.608,98.87a15.387,15.387,0,0,0-15.06,18.464.9.9,0,0,1,.013.092c1.262,15.426,12.051,25.9,30.418,29.575V114.241A15.389,15.389,0,0,0,24.608,98.87",
    transform: "translate(794.542 530.134)",
    fill: "#3a9ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M36.418,124.423a8.548,8.548,0,1,1,8.548-8.548,8.558,8.558,0,0,1-8.548,8.548m0-15.543a6.994,6.994,0,1,0,6.994,6.994,7,7,0,0,0-6.994-6.994",
    transform: "translate(790.038 527.901)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M43.036,118.2a4.291,4.291,0,1,1-4.291-4.291,4.291,4.291,0,0,1,4.291,4.291",
    transform: "translate(787.712 525.574)",
    fill: "#98b47b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 4.424,
    height: 4.291,
    transform: "translate(826.457 639.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M16.17,124.423a8.548,8.548,0,1,1,8.548-8.548,8.558,8.558,0,0,1-8.548,8.548m0-15.543a6.994,6.994,0,1,0,6.994,6.994,7,7,0,0,0-6.994-6.994",
    transform: "translate(794.556 527.901)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M22.788,118.2a4.291,4.291,0,1,1-4.291-4.291,4.291,4.291,0,0,1,4.291,4.291",
    transform: "translate(792.229 525.574)",
    fill: "#98b47b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 4.424,
    height: 4.291,
    transform: "translate(810.726 639.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M28.188,130.77,24.8,125.6l3.065-3.329,3.066,3.329Z",
    transform: "translate(790.723 524.565)",
    fill: "#fbbc3d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "matrix(0.978, -0.208, 0.208, 0.978, 827.422, 651.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M7.368,26.687S-9.21,13.669,7.368,0Z",
    transform: "translate(0.777 0.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M8.145,28.241a.778.778,0,0,1-.48-.166C7.357,27.832.1,22.041,0,13.932-.057,9.039,2.517,4.411,7.651.178a.777.777,0,0,1,1.271.6V27.464a.778.778,0,0,1-.777.777M7.368,2.484C3.464,6.083,1.51,9.919,1.555,13.9c.061,5.4,3.8,9.812,5.813,11.8Z",
    transform: "translate(0 0)",
    fill: "#3a9ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M3.073,14.864a.777.777,0,0,1-.639-.334c-5.483-7.9,0-14.209.059-14.271A.777.777,0,0,1,3.654,1.292c-.195.22-4.713,5.478.057,12.352a.777.777,0,0,1-.638,1.22",
    transform: "translate(3.917 6.689)",
    fill: "#3a9ddd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M24.123,111.466a.777.777,0,0,1-.764-.638c-1.014-5.59-7.276-9.8-14.565-9.8a.777.777,0,1,1,0-1.554c8.029,0,14.948,4.763,16.094,11.08a.776.776,0,0,1-.765.916",
    transform: "translate(794.468 529.653)",
    fill: "#3a9ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M28.527,111.466a.776.776,0,0,1-.765-.916c1.147-6.317,8.066-11.08,16.095-11.08a.777.777,0,1,1,0,1.554c-7.29,0-13.551,4.215-14.566,9.8a.777.777,0,0,1-.764.638",
    transform: "translate(790.065 529.653)",
    fill: "#3a9ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M38.878,116.123a2.212,2.212,0,1,1-2.212-2.212,2.212,2.212,0,0,1,2.212,2.212",
    transform: "translate(774.06 528.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M38.878,116.123a2.212,2.212,0,1,1-2.212-2.212,2.212,2.212,0,0,1,2.212,2.212",
    transform: "translate(789.79 528.142)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoeOwlIcon);
export default __webpack_public_path__ + "static/media/moe-owl-icon.d013aabe29d7a8232ab1451d487d7727.svg";
export { ForwardRef as ReactComponent };